import { Kb3dModel } from '../decorators/kb3d-decorator';
import { INormalSmoothingFeature, IVertexGroup } from '../kb3d-models';
import { Token } from '../token';
import { ALL_GEOMETRY, Feature } from './feature';

@Kb3dModel({
    token: Token.NormalSmoothingFeature,
})
export class NormalSmoothingFeature extends Feature implements INormalSmoothingFeature {
    //static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    vertexGroups: Array<Required<IVertexGroup>> = [];
    smooth = true;
}
